import "./AboutSection.css";
import groupImg from "../assets/about.b9303a939c8da758db0d.jpg";
import { useEffect } from "react";

export default function AboutSection() {
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add("visible");
      });
    });       
    document.querySelectorAll(".fade-up").forEach(el => observer.observe(el));
  }, []);

  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-left fade-up">
          <h2>About Bihani Children's Academy</h2>

          <p>
            At Bihani Children's Academy, we believe education is a lifelong journey 
            that shapes character, inspires creativity, and builds confidence.
          </p>

          <p>
            Effective learning goes beyond classrooms. That is why we offer academic 
            excellence along with extracurricular opportunities to help students discover 
            their true interests and passions.
          </p>

          <p>
            Our commitment to value-based education makes Bihani Children's Academy 
            a nurturing and empowering place for every learner.
          </p>
        </div>

        <div className="about-right fade-up">
          <img src={groupImg} alt="School Group" />
        </div>
      </div>
      <div className="bca-footer-cityscape"></div>  
    </section>
  );
}